import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { resolveLanguage } from '@/application/i18n/language'
import { investigationSlug } from '@/application/seo/investigation-url'
import { ArticleMeta } from './ArticleMeta'
import type { Investigation } from '@/domains/types'

/** 3-up card grid: image + headline + byline. */
export function HomeSecondaryGrid({ investigations }: { investigations: Investigation[] }) {
  const { t, i18n } = useTranslation()
  const locale = resolveLanguage(i18n.language)
  if (investigations.length === 0) return null

  return (
    <div>
      <h2 className="font-serif text-lg font-bold text-foreground border-b-2 border-border pb-2 mb-4">
        {t('home.secondary_title')}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {investigations.map((investigation) => (
          <Link
            key={investigation.id}
            to="/investigations/$slug"
            params={{ slug: investigationSlug(investigation, locale) }}
            className="group block no-underline hover:no-underline"
          >
            <div className="w-full aspect-video bg-muted overflow-hidden rounded-lg mb-3">
              <img
                src={investigation.imageUrl || '/logo.png'}
                alt={investigation.name}
                className={`w-full h-full transition-transform duration-300 group-hover:scale-105 ${
                  investigation.imageUrl ? 'object-cover' : 'object-contain p-6 opacity-40'
                }`}
              />
            </div>
            <h3 className="font-serif text-base font-bold text-foreground group-hover:text-primary line-clamp-2">
              {investigation.name}
            </h3>
            <ArticleMeta investigation={investigation} className="mt-1" />
          </Link>
        ))}
      </div>
    </div>
  )
}
